module.exports = __webpack_public_path__ + "static/media/imaginxp-loginbanner-2.d38d6b36.jpg";